import { Component, OnInit, OnDestroy, AfterViewInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';

import { OfferCrosssaleBundleComponent } from './offer-crosssale-bundle/offer-crosssale-bundle.component'

import * as _ from 'lodash';
import {ItemInfoDialogComponent} from "../../dialogs/item-info-dialog/item-info-dialog.component";
declare const $: any;

@Component({
    selector: 'app-offer',
    templateUrl: './offer.component.html',
    styleUrl: './offer.component.scss',
    standalone: false
})
export class OfferComponent implements OnInit, AfterViewInit, OnDestroy {
	$storage;
	catalog;

	isEdit;
	isDuplicate: boolean = false;
	originalItem: any;
	viewItem: any;
	currentItem: any;

	displayMode: string = 'wizard';
	wizardStep: number = 0;
	isWizard: boolean = false;
	wizardSteps: number = null;
	wizardStepGroups = [];
	wizardStepsParsed = [];
	isLastStep: boolean = true;
	isSummaryStep: boolean = false;
	isGroupsOnly: boolean = false;
	hasCrossSale: boolean = false;
	showItemGroupsFirstInWizard: boolean = false;
	showItemGroupsFirstInTab: boolean = false;

	modifierStep: number = 0;
	maxOfferCount: number;
	summary = [];
	nutritionalData: any;
	cardStyle: any = { "background-size": "100% auto", "background-position": "center" }
	hideItemImage: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<OfferComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialog: MatDialog,
		public appService: AppService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
	) {
		this.$storage = this.orderService.$storage;
		this.catalog = this.$storage.catalog;
		this.isEdit = this.data.isEdit;
		this.maxOfferCount = this.orderService.getMaxRemainingItems();
		this.showItemGroupsFirstInWizard = this.data.offer._offer.showItemGroupsFirstInWizard;
		this.showItemGroupsFirstInTab = this.data.offer._offer.showItemGroupsFirstInTab;

		if (this.data.isEdit) {
			this.originalItem = this.data.offer;
			if (this.originalItem) {
				this.viewItem = _.cloneDeep(this.originalItem);
				if (!this.viewItem.quantity) this.viewItem.quantity = 1;
				this.maxOfferCount += this.viewItem.quantity;
				this.currentItem = this.viewItem._item;
			} else {
				alert("can't find basket item")
			}
		} else {
			this.viewItem = _.cloneDeep(this.data.offer);
			this.viewItem.upsaleType = this.data.upsaleType;
			this.orderUtils.prepareViewItem(this.$storage.catalog, this.viewItem);

			if (this.viewItem.isWeight) {
				let weightParams = this.$storage.catalog.weightParams;
				this.viewItem.pricePer = this.appService.translate("_WEIGHT.price_per_weight", { unit: weightParams.baseTxt, price: this.appService.parseCurrency(this.viewItem.price) });
				this.viewItem.total = 0;
				this.viewItem.uom = weightParams.base;
				this.viewItem.units = _.get(this.viewItem, '_item.packageSize.units', weightParams.default);
				this.currentItem = this.viewItem._item;
				this.calculateWeightTotal();
				delete this.viewItem.crossSale;
			} else {
				if (this.viewItem.crossSale) {
					this.showItemGroupsFirstInWizard = false;
					this.hasCrossSale = true;
					this.orderUtils.prepareItem(this.$storage.catalog, this.viewItem._item, this.viewItem);
					this.isLastStep = false;
				} else {
					this.orderUtils.prepareSelectItem(this.$storage.catalog, this.viewItem);
				}

				if (!this.viewItem.total) this.viewItem.total = this.viewItem.price;
				if (this.viewItem._item && this.viewItem._item._addPrice) {
					this.viewItem.total += this.viewItem._item._addPrice;
				}
			}
			if (!this.viewItem.quantity) this.viewItem.quantity = 1;
			this.currentItem = this.viewItem._item;
		}

		this.nutritionalData = this.getNutritionData(this.viewItem);

		let _cardStyle = this.viewItem.cardStyle;
		if (_cardStyle["background-size"] != '100% 100%' || _cardStyle["background-color"]) {
			this.cardStyle["background-size"] = _cardStyle["background-size"];
			this.cardStyle["background-color"] = _cardStyle["background-color"];
		}

		let isValid = this.orderUtils.validateOffer(this.viewItem);

		let hasVisibleModGroups = this.currentItem && _.find(this.currentItem.modifierGroups, { _visible: true }) != null;

		if (this.viewItem.wizard && this.viewItem.wizard.length) {
			if (this.viewItem.wizard.length > 1) {
				//this.wizardStepsParsed = [...this.viewItem.wizard, { name: this.appService.translate("offer_summary_step"), groups: [], isSummary: true }];
				//this.isWizard = true;
				//this.wizardSteps = this.viewItem.wizard.length + 1;
				this.wizardStepsParsed = [...this.viewItem.wizard];
				this.isLastStep = false;
			} else {
				this.wizardStepsParsed = [...this.viewItem.wizard];
				this.isLastStep = true;
			}
		} else {
			let decisions = [], modifiers = [], itemGroups = [];
			_.each(this.currentItem.modifierGroups, modGroup => {
				if (modGroup.singleSelection) decisions.push(modGroup);
				else modifiers.push(modGroup);
			});
			_.each(this.viewItem._offer.selectionGroups, selectGroup => {
				itemGroups.push(selectGroup);
			});
			this.wizardStepsParsed.push({ index: 0, members: [...decisions, ...modifiers, itemGroups] });
		}

		if (!this.hasCrossSale) {
			this.checkOfferPromotion(this.data.offer?.offer);
		}
	}

	ngOnInit() {
		$('body').on('mousedown.popclickhandler', () => { $('.popactive').removeClass('popactive'); });

	}

	intersectionObserver: IntersectionObserver;
	ngAfterViewInit() {
		const ModelViewerElement = customElements.get('model-viewer');
		if (ModelViewerElement) ModelViewerElement["minimumRenderScale"] = 1;

		const titles = document.getElementsByClassName('members-deck-header');
		this.intersectionObserver = new IntersectionObserver(
			([e]) => {
				e.target.classList.toggle("stuck", e.intersectionRatio < 1 && e.intersectionRatio > 0.9);
			}, { threshold: [1] }
		);
		for (let i = 0; i < titles.length; i++) {
			const el = titles[i];
			this.intersectionObserver.observe(el);
		}
	}

	ngOnDestroy() {
		this.intersectionObserver.disconnect();
		$('body').off('mousedown.popclickhandler');
	}

	setOfferQuantity = function (op) {
		let newQuantity = this.viewItem.quantity + op;
		if (newQuantity < 1) {
			if (this.isEdit) {
				this.appService.confirm({
					"content": this.appService.translate("TO.q_remove_offer_from_basket"),
					showCancelButton: true,
					confirmText: this.appService.translate("remove")
				}).then(() => {
					this.dialogRef.close({mode: 'delete'});
				});
			} else {
				this.cancel();
			}
		} else {
			if (newQuantity > this.maxOfferCount) return;
			this.viewItem.quantity = newQuantity;
		}
	}

	getStepGroups(index?) {
		if (isNaN(index)) index = this.wizardStep;
		if (index === this.modifierStep) return _.filter(this.viewItem._offer.selectionGroups, { _display: 'inline' });
		else {
			let wizardIndex = this.showItemGroupsFirstInWizard ? index : index - 1;
			return [this.viewItem.wizard[wizardIndex]];
		}
	}

	stepBack() {
		if (this.wizardStep === 0) this.dialogRef.close(null);
		else this.setStep(null, -1);
	}

	onItemGroupSelect() {
		if (this.wizardStepsParsed.length > 1) this.setStep(null, 1);
	}
	setStep(index?, op?) {
		if (op) index = this.wizardStep + op;
		if (index < this.wizardStep) {
			if (index < 0) return;

		} else if (index > this.wizardStep) {
			index = this.wizardStep + 1;
			//if (index - this.wizardStep > 1) return;
			if (!this.validateStep()) return;
		}
		this.wizardStep = index;
		this.isLastStep = this.wizardStep == (this.wizardSteps - 1);
		this.isSummaryStep = this.isLastStep && this.isWizard;
		if (this.isSummaryStep) {
			this.summary = this.orderUtils.prepareOfferSummary_ex(this.viewItem, this.showItemGroupsFirstInWizard, this.showItemGroupsFirstInTab);
		}
	}

	submit() {
		if (!this.validateStep()) return;
		if (this.promoParams.promo) this.offerPromotionSubmit();
		else {
			this.orderUtils.prepareOfferSummary(this.viewItem, true);
			this.dialogRef.close({
				viewItem: this.viewItem
			});
		}
	}

	cancel() {
		this.dialogRef.close();
	}

	validateStep() {
		let that = this;
		let arrErrors = [], highlightId: string, min: number, selected: number;

		const _step = this.wizardStepsParsed[this.wizardStep];
		if (!_step || _step.isSummary) return true;
		for (let group of _step.members) {
			if (group.modifierGroup) {
				if (group.singleSelection) {
					var mod = _.find(group.modifiers, { '_selected': true });
					if (!mod) {
						arrErrors.push(this.appService.translate("GROUP_VALIDATION.GROUP_MOD_SELECT_SINGLE_ERROR", { group: group.name }));
					}
				} else {
					if (this.orderUtils.checkModGroupSelection(group)) {
						arrErrors.push(group.name + ": " + group._requieredMessage);
					}
				}
				if (arrErrors.length) {
					group._requiered = true;
					group.collapsed = false;
					highlightId = `mg_${group._id}`;
					break;
				}
			} else {
				min = group.minSelectionCount;
				selected = that.orderUtils.getItemGroupSelectionCount(group);

				if (selected < min) {
					group._requiered = true;
					group.collapsed = false;
					arrErrors.push(that.appService.translate(min == 1 ? 'GROUP_VALIDATION.GROUP_SELECT_SINGLE_ERROR' : 'GROUP_VALIDATION.GROUP_SELECT_ERROR', { count: min, group: group.name }));
					if (arrErrors.length == 1) {
						highlightId = `ig_${group._id}`;
						break;
					}
				}
			}
		}
		if (arrErrors.length) {
			this.appService.alert({ content: arrErrors[0] }).then(() => {
				that.orderUtils.highlightElement(highlightId);
			});

		} else {
			return true;
		}
	}

	// ----------------------------------------------------------------------------->
	// weight
	// ----------------------------------------------------------------------------->

	//-------------------------------------------------------------------------------------------->

	incrementWeight(_op) {
		let weightParams = this.$storage.catalog.weightParams;
		let op = weightParams.increment * _op;
		this.viewItem.units = this.viewItem.units + op;
		this.calculateWeightTotal();
	}

	onWeightEnter() {
		this.calculateWeightTotal();
	}

	calculateWeightTotal() {
		let weightParams = this.$storage.catalog.weightParams;
		let units = Math.max(this.viewItem.units, weightParams.min);
		let mod = units % weightParams.round;
		if (mod) units += (weightParams.round - mod);
		units = _.round(units, weightParams.decimals);

		this.currentItem.$summary = `${units} ${weightParams.useTxt}`;

		this.viewItem.baseUnits = units / weightParams.ratio;
		this.viewItem.units = units;
		this.viewItem.total = _.round(units / weightParams.ratio * this.viewItem.price, 2);
	}

	// ----------------------------------------------------------------------------->
	// selection groups
	// ----------------------------------------------------------------------------->

	initCrossSale() {
		if (!this.validateStep()) return;
		let addPrice = this.viewItem.total - this.viewItem.price;
		let dialogRef = this.dialog.open(OfferCrosssaleBundleComponent, {
			backdropClass: 'kiosk-bundle-dialog-backdrop',
			panelClass: 'kiosk-bundle-dialog',
			disableClose: true,
			maxWidth: 880,
			minWidth: 880,
			data: {
				group: this.viewItem.crossSale,
				addPrice: addPrice,
				minWidth: 280,
				submit: (result) => {
					if (!result) result = this.data.offer;
					this.applyCrossSale(result, addPrice);
				}
			},
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(result => {

		});
	}

	applyCrossSale(offer, addPrice) {
		this.hasCrossSale = false;
		let viewItem = _.cloneDeep(offer);
		viewItem.upsaleType = offer.offer != this.viewItem.offer ? 'offerUpgrade' : this.data.upsaleType;

		this.orderUtils.prepareViewItem(this.$storage.catalog, viewItem);
		this.orderUtils.prepareSelectItem(this.$storage.catalog, viewItem, true);

		delete viewItem._offer.view;
		delete viewItem._offer.showItemGroupsFirstInTab;
		delete viewItem._offer.showItemGroupsFirstInWizard;

		viewItem._item = this.currentItem;
		viewItem.wizard = this.orderUtils.getOfferGenericView(this.$storage.catalog, viewItem);

		viewItem.quantity = this.viewItem.quantity;
		viewItem.total = viewItem.price + addPrice;

		this.viewItem = viewItem;
		this.currentItem = this.viewItem._item;

		this.wizardStepsParsed = [];
		this.checkOfferPromotion(this.viewItem.offer);

		const hasSelectionGroups = _.find(this.viewItem._offer.selectionGroups, group => group._visible) != null;
		if (this.viewItem.wizard && this.viewItem.wizard.length) {
			if (!hasSelectionGroups) {
				return this.submit();
			}
			this.isWizard = true;
			this.wizardSteps = this.viewItem.wizard.length + 1;
			this.wizardStepsParsed = [...this.viewItem.wizard, { name: this.appService.translate("offer_summary_step"), groups: [], isSummary: true }];
			this.isLastStep = false;

			setTimeout(() => { this.setStep(null, 1); }, 100);

		} else {
			let decisions = [], modifiers = [], itemGroups = [];
			_.each(this.currentItem.modifierGroups, modGroup => {
				if (modGroup.singleSelection) decisions.push(modGroup);
				else modifiers.push(modGroup);
			});
			_.each(this.viewItem._offer.selectionGroups, selectGroup => {
				itemGroups.push(selectGroup);
			});
			this.wizardStepsParsed.push({ index: 0, members: [...decisions, ...modifiers, itemGroups] });
			this.submit();
		}
	}

	// ================================================================= >

	getNutritionData(item) {
		const info = item._item.nutritionalData?.htmlContent;
		const attributes = item.nutritionAttributes;
		if (info || attributes) return {info, attributes};
	}
	showItemInfo() {
		this.dialog.open(ItemInfoDialogComponent, {
			panelClass: 'rounded-dialog',
			//backdropClass: 'dialog-backdrop-dark',
			direction: this.appService.direction,
			//maxWidth: 880,
			data: this.nutritionalData,
			autoFocus: false
		});
	}

	// ================================================================= >
	// ================================================================= >
	// ================================================================= >

	promoParams: any = {
		active: false
	}

	checkOfferPromotion(offerId) {
		if (this.data.fromOBenefit) return;
		let target = this.$storage.loyaltyOffersMap;
		let offerPromotion = target && !target.disabled && target[offerId];
		if (offerPromotion) {


			let remainingPoints = target.remainingPoints;
			let inititalPoints = _.get(this.viewItem, '_reserved.points', 0);
			remainingPoints += inititalPoints;


			let remainingUses = target.remainingUses;
			let inititalQuantity = _.get(this.viewItem, '_reserved.quantity', 0);
			remainingUses += inititalQuantity;

			if (remainingUses > 0 && remainingPoints >= offerPromotion.price) {
				this.promoParams.promo = offerPromotion;
				this.promoParams.price = offerPromotion.price;
				this.promoParams.inititalPoints = inititalPoints;
				this.promoParams.remainingPoints = remainingPoints;
				this.promoParams.remainingUses = remainingUses;
			}
		}
	}

	offerPromotionSubmit(ev?) {
		if (ev) ev.stopPropagation();
		let newPoints, points = 0, quantity = 0, money = this.viewItem.total * this.viewItem.quantity;
		for (var i = 0; i < this.viewItem.quantity; i++) {
			if (i == this.promoParams.remainingUses) break;
			newPoints = points + this.promoParams.price;
			if (newPoints > this.promoParams.remainingPoints) break;
			points = newPoints;
			money -= this.viewItem.price;
			++quantity;
		}
		this.promoParams.points = points;
		this.promoParams.money = money;
		this.promoParams.quantity = quantity;
		this.promoParams.active = true;
	}

	applyWithPromotion(mode, ev) {
		if (ev) ev.stopPropagation();

		let target = this.$storage.loyaltyOffersMap;
		target._used += this.promoParams.inititalPoints;

		if (mode == 'points') {
			target._used -= this.promoParams.points;
			this.viewItem._reserved = {
				...this.promoParams.promo.category,
				...{
					points: this.promoParams.points,
					money: this.promoParams.money,
					quantity: this.promoParams.quantity
				}
			}
		}
		this.orderUtils.prepareOfferSummary(this.viewItem, true);
		this.dialogRef.close({
			viewItem: this.viewItem
		});
	}
}
